export enum AssessmentExportFormat {
    Pdf = 'pdf',
    Docx = 'docx',
}

export enum AssessmentExportedQuestionTypeEnum {
    Group = 'group',
    Text = 'text',
    Textarea = 'textarea',
    TextBlock = 'text-block',
    Datepicker = 'datepicker',
    File = 'file',
    Dropdown = 'dropdown',
    NewSection = 'new-section',
    CustomComponent = 'custom-component',
    BusinessPurpose = 'businessPurpose',
    MultipleChoice = 'multipleChoice',
    DataSources = 'dataSources',
    Risks = 'risks',
    DataSubjects = 'dataSubjects',
    BusinessUnit = 'businessUnit',
    DataRole = 'dataRole',
    DataTypes = 'dataTypes',
    LegalBasis = 'legalBasis',
    TransferMechanism = 'transferMechanism',
    BusinessOwner = 'businessOwner',
    PartiesWithAccess = 'partiesWithAccess',
    DpiaNeeded = 'dpiaNeeded',
    LinkedAssessment = 'linkedAssessment',
    DataFlow = 'dataFlow',
    DataFlowNeeded = 'dataFlowNeeded',
  }